import type { ReactNode } from 'react';
import { Breadcrumbs, type BreadcrumbItem } from '@/shared/components/Breadcrumbs';
import { CommandBar, type CommandBarProps } from '@/shared/components/CommandBar';
import { StatusBadge } from '@/shared/components/StatusBadge';

export type ResourcePageHeaderProps = {
  title: string | ReactNode;
  subtitle?: string;
  status?: string;
  environment?: string;
  breadcrumbs: BreadcrumbItem[];
  commandBar?: CommandBarProps;
  badges?: ReactNode;
  titleActions?: ReactNode;
};

/** Entity header for Resource Hub pages — title, status, breadcrumbs, actions. */
export function ResourcePageHeader({
  title,
  subtitle,
  status,
  environment,
  breadcrumbs,
  commandBar,
  badges,
  titleActions,
}: ResourcePageHeaderProps) {
  return (
    <div className="space-y-4 rounded-lg border border-border bg-card p-4 md:p-6">
      <Breadcrumbs items={breadcrumbs} />
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            {typeof title === 'string' ? (
              <h1 className="text-xl font-semibold tracking-tight md:text-2xl">{title}</h1>
            ) : (
              title
            )}
            {titleActions}
            {status && <StatusBadge status={status} />}
            {environment && <StatusBadge status={environment} />}
            {badges}
          </div>
          {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        {commandBar && <CommandBar {...commandBar} />}
      </div>
    </div>
  );
}
